var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social/outline/youtube"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1083",
    x: 2.5,
    y: 3,
    width: 20,
    height: 18,
    rx: 4,
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2900",
    d: "M10.9472 8.72361L15.7111 11.1056C16.4482 11.4741 16.4482 12.5259 15.7111 12.8944L10.9472 15.2764C10.2823 15.6088 9.5 15.1253 9.5 14.382V9.61803C9.5 8.87465 10.2823 8.39116 10.9472 8.72361Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubef);
export default __webpack_public_path__ + "static/media/youtubef.c9c4e5e1b7aa83cdc1a9bac8c0a7a0d1.svg";
export { ForwardRef as ReactComponent };